/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".graphPanelHeader{background:#fafafa;border:1px solid #eee;border-left-width:0;padding-left:10px;text-transform:uppercase;font-size:.9rem;letter-spacing:3px;line-height:30px;width:267px;left:0;top:0}.edge-panel-card{width:285px;background:#fff;padding:20px}"];
export { styles as styles };
